'use strict';

var Sentry = require('@sentry/react');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var Sentry__namespace = /*#__PURE__*/_interopNamespaceDefault(Sentry);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var ENVIRONMENTS;
(function (ENVIRONMENTS) {
    ENVIRONMENTS["PRODUCTION"] = "production";
    ENVIRONMENTS["STAGING"] = "staging";
    ENVIRONMENTS["DEVELOPMENT"] = "development";
})(ENVIRONMENTS || (ENVIRONMENTS = {}));

async function loadConfigFile (dsn) {
    const dsnPublicKey = dsn.match(/https:\/\/([^@]+)@/)?.[1];
    return new Promise(async (resolve) => {
        try {
            //
            const response = await fetch(`https://observability.hotmart.com/config-files/${dsnPublicKey}.json`);
            const blob = await response.blob();
            const read = new FileReader();
            read.onload = function() {
                resolve(JSON.parse(read.result));
            };
            read.readAsText(blob);
        }
        catch(e) {
            resolve({});
        }
    });
}

const commonIgnorableErrors = [
    /OPTIMIZELY/i,
    'AbortError: The transaction was aborted, so the request cannot be fulfilled.',

    // Random plugins/extensions
    'top.GLOBALS',
    /* eslint-disable quotes */
    "Unexpected token '<'",
    'Extension context invalidated.',
    "SecurityError: Failed to read the 'cssRules' property from 'CSSStyleSheet': Cannot access rules",
    "Cannot read property 'isMew' of undefined",
    "Cannot read property 'removeChild' of null",
    'Load timeout for modules: main http://requirejs.org/docs/errors.html#timeout',
    "Cannot set property 'className' of null",
    "Cannot read property 'toolBar' of undefined",
    "Cannot read property 'query' of undefined",
    "Cannot read property 'NaN' of undefined",
    "Identifier 'originalPrompt' has already been declared",
    'There is no clipping info for given tab',
    'x5onSkinSwitch is not defined',
    'KasperskyLab is not defined',
    'ibPauseAllVideos is not defined',
    'ibFindAllVideos is not defined',
    "undefined is not an object (evaluating 'safari.self.tab.setContextMenuEventUserInfo')",

    // iOS error related to google app search
    "null is not an object (evaluating 'elt.parentNode')",

    // Meteor ERRORS
    'INVALID_STATE_ERR',
    'NS_ERROR_SOCKET_CREATE_FAILED',

    // ignoring requests without object
    'Non-Error promise rejection captured',

    // ignoring gtm.js errors
    'No error message',
    'elements.forEach is not a function',
    "Cannot read property 'innerText' of null",
    "Object doesn't support property or method 'forEach'",
    "Unable to get property 'innerText' of undefined or null reference",
    "null is not an object (evaluating 'element.innerText')",
    "Identifier 'selectors' has already been declared",
    'fbq is not defined',
    "Can't find variable: fbq",

    // avast extension error
    "Cannot read property '_avast_submit' of undefined",

    // Firebase connection errors - omnichat
    'UnknownError: An internal error was encountered in the Indexed Database server',
    'UnknownError: Attempt to get a record from database without an in-progress transaction',
    'PERMISSION_DENIED: Permission denied',
    'Uncaught Error in onSnapshot: FirebaseError: Missing or insufficient permissions.',
    "The project's quota for this operation has been exceeded.",
    'INTERNAL ASSERTION FAILED: Unexpected state',
    'UnknownError: Database deleted by request of the user',

    // Request aborted warnings in console from @hotmart/request
    'Request aborted',

    // External errors
    "Cannot read property 'campaign' of undefined",

    // Navigator share api canceled reject error
    'AbortError: Share canceled',
    'AbortError: Internal error: could not connect to Web Share interface.',
    'AbortError: Abort due to cancellation of share.',

    "null is not an object (evaluating 'a[w.checkoutSettingKeys.devToolsEnabled]')"
];

const commonDenyUrls = [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i,
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    // Google
    /google.com/i,
    /gtm.js/i,
];

var EXTRA_KEY = "ROUTE_TO";
var transport = Sentry__namespace.makeMultiplexedTransport(Sentry__namespace.makeFetchTransport, function (args) {
    var event = args.getEvent(['event', 'transaction', 'replay_event']);
    if (event &&
        event.extra &&
        EXTRA_KEY in event.extra &&
        Array.isArray(event.extra[EXTRA_KEY])) {
        return event.extra[EXTRA_KEY];
    }
    return [];
});
var initSentry = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var isEnvProduction, customConfig, _c, error_1;
    var dsn = _b.dsn, environment = _b.environment, release = _b.release, _d = _b.debug, debug = _d === void 0 ? false : _d, _e = _b.dynamicSetup, dynamicSetup = _e === void 0 ? false : _e, _f = _b.disableCaptureConsoleIntegration, disableCaptureConsoleIntegration = _f === void 0 ? false : _f, _g = _b.useCommonErrorsFilter, useCommonErrorsFilter = _g === void 0 ? true : _g, ignoreErrors = _b.ignoreErrors, _h = _b.useCommonUrlsFilter, useCommonUrlsFilter = _h === void 0 ? true : _h, denyUrls = _b.denyUrls;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                _j.trys.push([0, 4, , 5]);
                isEnvProduction = environment === ENVIRONMENTS.PRODUCTION;
                if (!dynamicSetup) return [3 /*break*/, 2];
                return [4 /*yield*/, loadConfigFile(dsn)];
            case 1:
                _c = _j.sent();
                return [3 /*break*/, 3];
            case 2:
                _c = {};
                _j.label = 3;
            case 3:
                customConfig = _c;
                Sentry__namespace.init({
                    dsn: dsn,
                    environment: environment,
                    release: release,
                    debug: debug,
                    integrations: __spreadArray(__spreadArray([
                        Sentry__namespace.moduleMetadataIntegration(),
                        Sentry__namespace.browserTracingIntegration()
                    ], __read((disableCaptureConsoleIntegration ?
                        [] :
                        [Sentry__namespace.captureConsoleIntegration({ levels: ['error'] })])), false), [
                        Sentry__namespace.httpClientIntegration()
                    ], false),
                    transport: transport,
                    beforeSend: function (event) {
                        var _a;
                        var _b, _c, _d;
                        if ((_d = (_c = (_b = event === null || event === void 0 ? void 0 : event.exception) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c[0].stacktrace) === null || _d === void 0 ? void 0 : _d.frames) {
                            var frames_1 = event.exception.values[0].stacktrace.frames;
                            // Find the last frame with module metadata containing a DSN
                            var routeTo = frames_1
                                .filter(function (frame) { return frame.module_metadata && frame.module_metadata.dsn; })
                                .map(function (v) { return v.module_metadata; })
                                .slice(-1); // using top frame only - you may want to customize this according to your needs
                            if (routeTo.length) {
                                event.extra = __assign(__assign({}, event.extra), (_a = {}, _a[EXTRA_KEY] = routeTo, _a));
                            }
                        }
                        return event;
                    },
                    ignoreErrors: __spreadArray(__spreadArray([], __read((useCommonErrorsFilter ? commonIgnorableErrors : [])), false), __read((ignoreErrors ? ignoreErrors : [])), false),
                    denyUrls: __spreadArray(__spreadArray([], __read((useCommonUrlsFilter ? commonDenyUrls : [])), false), __read((denyUrls ? denyUrls : [])), false),
                    tracesSampleRate: isEnvProduction ? customConfig.tracesSampleRate || 0 : 0,
                    profilesSampleRate: 0,
                });
                return [3 /*break*/, 5];
            case 4:
                error_1 = _j.sent();
                console.error(error_1);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };

var HotmartRum = {
    init: function (options) {
        return initSentry(options);
    },
    captureException: function (exception, hint) {
        return Sentry__namespace.captureException(exception, hint);
    },
    captureMessage: function (message, captureContext) {
        return Sentry__namespace.captureMessage(message, captureContext);
    },
    getCurrentScope: function () {
        return Sentry__namespace.getCurrentScope();
    },
    setTag: function (key, value) {
        return Sentry__namespace.setTag(key, value);
    },
    setUser: function (user) {
        return Sentry__namespace.setUser(user);
    },
    withScope: function (callback) {
        return Sentry__namespace.withScope(callback);
    },
    ErrorBoundary: Sentry__namespace.ErrorBoundary
};

exports.HotmartRum = HotmartRum;
//# sourceMappingURL=index.cjs.js.map
